
import React, { useCallback, useContext, useState } from "react";
import { Box, Button, ButtonBase, IconButton, InputAdornment, TextField, Tooltip, Typography } from "@mui/material";
import CheckRounded from '@mui/icons-material/CheckRounded';
import { AckDot, DRV_ACK, drvAckState, drvAckTitle } from "../DrvAck";
import { BoxFC, BoxFR } from "components/BoxCustom";
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime";
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { jobOrderApiNm, jobOrderColNm } from "constants/jobOrderConstant";
import dayjs from "dayjs";
import { blueGrey, grey } from "@mui/material/colors";
import ComboBox from "components/ComboBox";
import { modifyPOICombo } from "branch/functions/modifyPOICombo";
import { suggessDrvCombo } from "utils/suggessDrvCombo";
import { ArticleRounded, EditRounded } from "resource/muiImport";
import EditContStsTmDialog from "../EditContStsTmDialog";
import PopoverSearchJobOrder from "components/PopoverSerachJobOrder/PopoverSearchJobOrder";

import LensIcon from '@mui/icons-material/Lens';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import { alertError } from "components/Alert";
import DailyJobDialogV3 from "../DailyJobDialogV3";



const shortDateProp = {
  inputFormat: "DD/MM HH:mm",
  mask: "__/__ __:__"
}


const getObjNm = (contStsId) => {
  const objNm = {
    poiNm: "",
    arvNm: "",
    LevNm: "",
    aptSt: "",
    aptEn: "",
    rtnSt: "",
    rtnEn: ""
  }
  if (contStsId === 1) {
    objNm.poiNm = "TakePOIId"
    objNm.arvNm = "TakeArvTm"
    objNm.LevNm = "TakeLevTm"
    objNm.aptSt = "TakeDteSt"
    objNm.aptEn = "TakeDteEn"
  } else if (contStsId === 2) {
    objNm.poiNm = "Sts2POIId"
    objNm.arvNm = ""
    objNm.LevNm = ""
    objNm.aptSt = ""
    objNm.aptEn = ""
  } else if (contStsId === 3) {
    objNm.poiNm = "LocPOIId"
    objNm.arvNm = "ArvTm"
    objNm.LevNm = "LevTm"
    objNm.aptSt = "AptTm"
  } else if (contStsId === 4) {
    objNm.poiNm = "Sts4POIId"
    objNm.arvNm = ""
    objNm.LevNm = ""
    objNm.aptSt = ""
    objNm.aptEn = ""
  } else if (contStsId === 5) {
    objNm.poiNm = "RtnPOIId"
    objNm.arvNm = "RtnArvTm"
    objNm.LevNm = "RtnLevTm"
    objNm.aptSt = "RtnDteSt"
    objNm.aptEn = "RtnDteEn"
  }
  return objNm
}

let initStsTm = dayjs()
let editContStsId = null
let swpJobOrdId = null

const compactGridSx = {
  p: 1.5, display: "grid", gap: 1.5,
  gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(4, minmax(0, 1fr))" }
}
const fullRow = { gridColumn: "1 / -1" }

const ContStsComponent = ({ contStatusData, setContStsData, joData, setJOData, compact }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [dialogSwpDailyJobOpen, setDialogSwpDailyJobOpen] = useState(false)

  const datePickerJobOrderProp = useCallback((name, isRequire) => ({
    label: jobOrderColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: joData[name],
    onChange: (newValue) => { setJOData(oldState => ({ ...oldState, [name]: newValue && newValue.format("YYYY-MM-DD HH:mm:00.00") })) },
    renderInput: (params) => <TextField size="small"  {...params} required={isRequire} sx={{ width: compact ? "100%" : 140 }} />,
  }), [joData, setJOData, compact])


  const handleIsCmptClick = useCallback((index) => (e) => {
    setContStsData(o => {
      const newData = o.map(cs => ({ ...cs }))
      const contStsData = newData[index];
      contStsData.IsCmpt = contStsData.IsCmpt === 1 ? 0 : 1
      return newData
    })
  }, [setContStsData])

  const handleDrvIdChange = useCallback((index) => (id) => {
    const tukId = msData.drivers.find(drv => drv.DrvId === id)?.TukId || null
    let stsTm = null
    setContStsData(oldData => {

      const newData = oldData.map(cs => ({ ...cs }))
      const contSts = newData[index];


      if (id) {
        if (joData) {
          if (contSts.ContStsId === 1) {
            stsTm = joData.TakeDteSt && dayjs(joData.TakeDteSt).isAfter(dayjs()) ? dayjs(joData.TakeDteSt) : dayjs()
          } else if (contSts.ContStsId === 3) {
            stsTm = joData.AptTm && dayjs(joData.AptTm).isAfter(dayjs()) ? dayjs(joData.AptTm) : dayjs()
          } else if (contSts.ContStsId === 5) {
            stsTm = joData.RtnDteSt && dayjs(joData.RtnDteSt).isAfter(dayjs()) ? dayjs(joData.RtnDteSt) : dayjs()
          } else {
            stsTm = dayjs()
          }
        } else {
          stsTm = dayjs()
        }
      }

      contSts.DrvId = id;
      contSts.StsTm = stsTm
      contSts.DispTm = dayjs()
      contSts.TukId = tukId
      return newData
    })
    setJOData(o => ({
      ...o,
      DrvId: id,
      DrvActTm: id === null ? null : dayjs(),
      TukId: tukId,
      processDrvId: id
    }))

  }, [msData.drivers, joData, setContStsData, setJOData])

  const handleEditStsTm = useCallback((contStsData) => () => {
    initStsTm = contStsData.StsTm ? dayjs(contStsData.StsTm) : dayjs()
    editContStsId = contStsData.ContStsId
    setDialogOpen(true)
  }, [])

  const handleChangeStsTm = useCallback((newValue) => {
    setContStsData(o => {
      const newData = o.map(cs => ({ ...cs }))
      const found = newData.find(cs => cs.ContStsId === editContStsId)
      found.StsTm = newValue;
      return newData
    })
  }, [setContStsData])

  const handleSelectJobOrder = useCallback((item) => {
    setJOData(o => ({ ...o, SwpJobOrdId: item?.JobOrdId, SwpContNo: item?.ContNo }))
  }, [setJOData])

  const handleSwpJobOrdIdOnBlur = useCallback((e) => {
    if (e.target.value) {
      ax.post(jobOrderApiNm.getContainerData, { JobOrdId: e.target.value }).then(value => {
        if (value.data) {
          setJOData(o => ({ ...o, SwpContNo: value.data.ContNo }))
        } else {
          setJOData(o => ({ ...o, SwpJobOrdId: "", SwpContNo: "" }))
          alertError(`ไม่พบเลขที่ใบงาน ${e.target.value}`)
        }
      })
    } else {
      setJOData(o => ({ ...o, SwpContNo: "" }))
    }
  }, [ax, setJOData])

  const handleSwpIconClick = useCallback((id) => () => {
    const found = contStatusData.find(cs => cs.ContStsId === 3)
    if (!found?.DrvId) {
      alertError("กรุณาเลือพนักงานขับรถส่งตู้ก่อนทำการสลับตู้")
      return
    }
    setJOData(o => ({
      ...o,
      [`SwpDrvIdSts${id}`]: o[`SwpDrvIdSts${id}`] ? null : found.DrvId
    }))
  }, [contStatusData, setJOData])

  const handleOpenDailyJobDialog = useCallback(() => {
    swpJobOrdId = joData.SwpJobOrdId
    setDialogSwpDailyJobOpen(true)
  }, [joData.SwpJobOrdId])

  const nestedDialogs = (
    <>
      <DailyJobDialogV3
        selectedId={swpJobOrdId}
        dialogOpen={dialogSwpDailyJobOpen}
        setDialogOpen={setDialogSwpDailyJobOpen} />
      <EditContStsTmDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        initValue={initStsTm}
        setContStsTm={handleChangeStsTm} />
    </>
  )

  if (compact) {
    return (
      <BoxFC sx={{ gap: 1.5 }}>
        {contStatusData.map((cs, index) => {
          let sDrvId = null
          for (let i = index - 1; i >= 0; i--) {
            if (contStatusData[i]?.DrvId) {
              sDrvId = contStatusData[i].DrvId
              break
            }
          }
          const objNm = getObjNm(cs.ContStsId)
          const assigned = !!cs.DrvId
          const ackState = cs.DrvId === cs.AckDrvId ? drvAckState(cs, msData, joData.FinDte) : null
          return (
            <Box key={cs.ContStsId} component="section" aria-label={cs.Name} sx={{
              bgcolor: "background.paper", borderRadius: 2, overflow: "hidden",
              border: "2px solid", borderColor: `${cs.BgClr}.main`
            }}>
              <Box sx={{
                display: "flex", alignItems: "center", gap: 1, px: 1.5, minHeight: 48,
                bgcolor: assigned ? `${cs.BgClr}.main` : blueGrey[50], color: assigned ? "common.white" : "text.primary"
              }}>
                <Typography sx={{ fontWeight: 700, fontSize: 16 }}>{cs.Name}</Typography>
                {ackState === DRV_ACK.ACKED ?
                  <BoxFR sx={{ gap: 0.25 }}>
                    <CheckRounded fontSize="small" />
                    <Typography sx={{ fontSize: 13 }}>รับทราบ {dayjs(cs.DrvAckTm).format("HH:mm")}</Typography>
                  </BoxFR>
                  : ackState === DRV_ACK.PENDING ?
                    <BoxFR sx={{ gap: 0.5 }}>
                      <AckDot />
                      <Typography sx={{ fontSize: 13 }}>ยังไม่รับงาน</Typography>
                    </BoxFR>
                    : null
                }
                <Box flex={1} />
                {assigned ?
                  <ButtonBase onClick={handleEditStsTm(cs)} aria-label={`แก้เวลาจ่ายงาน ${cs.Name}`} sx={{
                    gap: 0.5, px: 1, minHeight: 36, borderRadius: 1, border: "1px solid rgba(255,255,255,0.6)"
                  }}>
                    <Typography sx={{ fontSize: 14, fontVariantNumeric: "tabular-nums" }}>
                      {cs.StsTm ? dayjs(cs.StsTm).format("DD/MM HH:mm") : "-"}
                    </Typography>
                    <EditRounded fontSize="small" />
                  </ButtonBase>
                  :
                  <Typography sx={{ fontSize: 13, color: "text.secondary" }}>ยังไม่จ่ายงาน</Typography>
                }
              </Box>
              <Box sx={compactGridSx}>
                <ComboBox options={modifyPOICombo(msData.poiCombo, "TAKE", joData.Shipment?.ShpmTypId)}
                  sx={{ width: "100%", gridColumn: { xs: "1 / -1", sm: "span 2" } }}
                  label={jobOrderColNm[objNm.poiNm]}
                  selectedId={joData[objNm.poiNm]}
                  setSelectedId={(id) => setJOData(o => ({ ...o, [objNm.poiNm]: id }))} />
                <ComboBox sx={{ width: "100%" }} options={suggessDrvCombo(sDrvId, msData.driverCombo)} required={false}
                  selectedId={cs.DrvId}
                  label="พนักงานขับรถ"
                  setSelectedId={handleDrvIdChange(index)}
                />
                <ComboBox sx={{ width: "100%" }} options={msData.truckCombo} required={false}
                  selectedId={cs.TukId}
                  label="เลขรถ"
                  setSelectedId={(id) => {
                    cs.TukId = id;
                    setContStsData(oldData => [...oldData])
                    setJOData(o => ({ ...o, TukId: id }))
                  }}
                />
                {[1, 3, 5].includes(cs.ContStsId) ?
                  <>
                    <Button sx={{ ...fullRow, minHeight: 44 }} disabled={!assigned}
                      variant={cs.IsCmpt === 1 ? "contained" : "outlined"}
                      color={cs.IsCmpt === 1 ? "success" : "inherit"}
                      startIcon={<FactCheckRoundedIcon />}
                      aria-pressed={cs.IsCmpt === 1}
                      onClick={handleIsCmptClick(index)}>
                      {cs.Name}เสร็จแล้ว
                    </Button>
                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.arvNm, false)} {...shortDateProp} />
                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.LevNm, false)} {...shortDateProp} />
                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.aptSt, false)} {...shortDateProp} />
                    {cs.ContStsId !== 3 ?
                      <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.aptEn, false)} {...shortDateProp} />
                      : null
                    }
                  </>
                  : null
                }
              </Box>
              {cs.ContStsId === 4 ?
                <Box sx={{ ...compactGridSx, pt: 0 }}>
                  <Box sx={{ ...fullRow, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                    <Typography sx={{ fontWeight: 600 }}>สลับตู้กลับ</Typography>
                    {["4", "5"].map(id => {
                      const on = !!joData[`SwpDrvIdSts${id}`]
                      const clr = msData.containerStatusObj[id]?.BgClr || "primary"
                      return (
                        <Button key={id} size="small" color={clr} variant={on ? "contained" : "outlined"}
                          aria-pressed={on} sx={{ minHeight: 36 }}
                          startIcon={on ? <LensIcon /> : <PanoramaFishEyeIcon />}
                          onClick={handleSwpIconClick(id)}>
                          {msData.containerStatusObj[id]?.Name}
                        </Button>
                      )
                    })}
                  </Box>
                  <TextField size="small" label="เลขที่ใบงานสลับกลับ" fullWidth type="number" sx={fullRow}
                    inputProps={{ inputMode: "numeric" }}
                    value={joData.SwpJobOrdId || ""} onChange={(e) => setJOData(o => ({ ...o, SwpJobOrdId: e.target.value }))}
                    onBlur={handleSwpJobOrdIdOnBlur}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">
                        <PopoverSearchJobOrder
                          handleSelectJobOrder={handleSelectJobOrder}
                          suggestDrvId={null}
                        />
                      </InputAdornment>,
                      endAdornment: <InputAdornment position="end">
                        <IconButton onClick={handleOpenDailyJobDialog} disabled={!joData.SwpContNo}
                          aria-label="เปิดใบงานสลับกลับ">
                          <ArticleRounded color={joData.SwpContNo ? "primary" : "disabled"} />
                        </IconButton>
                      </InputAdornment>
                    }} />
                  <TextField size="small" label="หมายเลขตู้" fullWidth value={joData.SwpContNo || ""}
                    InputProps={{ readOnly: true }} sx={{ gridColumn: { xs: "1 / -1", sm: "span 2" } }} />
                  <TextField size="small" label="ข้อมูลตู้ตัด" fullWidth InputProps={{ readOnly: true }}
                    sx={{ gridColumn: { xs: "1 / -1", sm: "span 2" } }}
                    value={joData.SwpJobOrdIdPrev === null ? "" : `${joData.SwpJobOrdIdPrev}:${joData.SwpContNoPrev}`} />
                </Box>
                : null
              }
            </Box>
          )
        })}
        {nestedDialogs}
      </BoxFC>
    )
  }

  return (
    <BoxFC sx={{ gap: 0.5 }}>
      {contStatusData.map((cs, index) => {
        let sDrvId = null
        for (let i = index - 1; i >= 0; i--) {
          if (contStatusData[i]?.DrvId) {
            sDrvId = contStatusData[i].DrvId
            break
          }
        }
        const objNm = getObjNm(cs.ContStsId)
        // 
        return (
          <BoxFC key={cs.ContStsId} >
            <BoxFR width="100%">
              <BoxFR sx={{
                border: `4px solid`, borderColor: `${cs.BgClr}.main`, borderRadius: 2
                , bgcolor: blueGrey[50], width: [2, 4].includes(cs.ContStsId) ? 600 : '100%'
              }} >
                <BoxFC width={130} height="100%" sx={{
                  gap: 0, p: 0.5, bgcolor: cs.DrvId ? `${cs.BgClr}.main` : blueGrey[50]
                  , alignItems: "center", justifyContent: "center", color: cs.DrvId ? "white" : "inherit"
                }}>
                  <BoxFR sx={{ gap: 0.5 }}>
                    <Typography >{cs.Name}</Typography>
                    {cs.DrvId === cs.AckDrvId && drvAckState(cs, msData, joData.FinDte) ?
                      <Tooltip title={drvAckTitle(cs.DrvAckTm)} arrow>
                        {drvAckState(cs, msData, joData.FinDte) === DRV_ACK.ACKED ?
                          <BoxFR sx={{ gap: 0.25 }}>
                            <CheckRounded fontSize="small" />
                            <Typography variant="body2">{dayjs(cs.DrvAckTm).format("HH:mm")}</Typography>
                          </BoxFR>
                          :
                          <BoxFR><AckDot /></BoxFR>
                        }
                      </Tooltip>
                      : null
                    }
                  </BoxFR>
                  <BoxFR>
                    <Typography>{cs.StsTm ? dayjs(cs.StsTm).format("DD/MM HH:mm") : "-"}</Typography>
                    {cs.DrvId ?
                      <IconButton sx={{ p: 0 }} onClick={handleEditStsTm(cs)}>
                        <EditRounded fontSize="small" sx={{ color: cs.DrvId ? "white" : "inherit" }} />
                      </IconButton>
                      : null
                    }
                  </BoxFR>

                </BoxFC>
                <ComboBox options={modifyPOICombo(msData.poiCombo, "TAKE", joData.Shipment?.ShpmTypId)}
                  sx={{ width: 150 }}
                  label={jobOrderColNm[objNm.poiNm]}
                  selectedId={joData[objNm.poiNm]}
                  setSelectedId={(id) => setJOData(o => ({ ...o, [objNm.poiNm]: id }))} />
                <ComboBox sx={{ width: 150 }} options={suggessDrvCombo(sDrvId, msData.driverCombo)} required={false}
                  selectedId={cs.DrvId}
                  label="พนักงานขับรถ"
                  setSelectedId={handleDrvIdChange(index)}
                />
                <ComboBox sx={{ width: 110 }} options={msData.truckCombo} required={false}
                  selectedId={cs.TukId}
                  label="เลขรถ"
                  setSelectedId={(id) => {
                    cs.TukId = id;
                    setContStsData(oldData => [...oldData])
                    setJOData(o => ({
                      ...o,
                      TukId: id
                    }))
                  }}
                />
                {[1, 3, 5].includes(cs.ContStsId) ?
                  <BoxFR>
                    <IconButton sx={{ p: 0.5, backgroundColor: "white" }} onClick={handleIsCmptClick(index)}
                      disabled={cs.DrvId ? false : true}>
                      <FactCheckRoundedIcon color={cs.IsCmpt === 1 ? "success" : "inherit"} />
                    </IconButton>

                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.arvNm, false)} {...shortDateProp} />
                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.LevNm, false)} {...shortDateProp} />
                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.aptSt, false)} {...shortDateProp} />
                    {cs.ContStsId !== 3 ?
                      <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.aptEn, false)} {...shortDateProp} />
                      : null
                    }

                  </BoxFR>
                  : null
                }
              </BoxFR>
              {cs.ContStsId === 4 ?
                <BoxFR sx={{
                  p: 1, position: "relative", border: `3px solid ${grey[500]}`
                  , borderColor: grey[500], bgcolor: grey[100], borderRadius: `4px`, flex: 1
                }} >
                  {/* <Typography variant="caption" position="absolute" top={-8} left={8} sx={{ bgcolor: "white", px: 0.5 }} >สลับตู้กลับ</Typography> */}
                  <BoxFC sx={{ gap: 0, alignItems: "center", px: 1 }}>
                    {/* <SwapHorizRounded sx={{ color: grey[600] }} /> */}
                    <Typography variant="body2">สลับกลับ</Typography>
                    <BoxFR >
                      {["4", "5"].map(id => (
                        <IconButton key={id} sx={{ p: 0 }} onClick={handleSwpIconClick(id)}>
                          {joData[`SwpDrvIdSts${id}`] ?
                            <LensIcon sx={{ color: `${msData.containerStatusObj[id].BgClr}.main` }} />
                            :
                            <PanoramaFishEyeIcon sx={{ color: `${msData.containerStatusObj[id].BgClr}.main` }} />
                          }
                        </IconButton>
                      ))}
                      {/* <CheckCircleRoundedIcon color={contSts.BgClr} />
                  :
                  <LensIcon color={contSts.BgClr} /> */}
                    </BoxFR>
                  </BoxFC>
                  <TextField size="small" label="เลขที่ใบงาน" sx={{ width: 150 }} type="number"
                    value={joData.SwpJobOrdId || ""} onChange={(e) => setJOData(o => ({ ...o, SwpJobOrdId: e.target.value }))}
                    onBlur={handleSwpJobOrdIdOnBlur}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">
                        <PopoverSearchJobOrder
                          handleSelectJobOrder={handleSelectJobOrder}
                          suggestDrvId={null}
                        />
                      </InputAdornment>,
                      endAdornment: <InputAdornment position="end">
                        <IconButton sx={{ p: 0 }} onClick={handleOpenDailyJobDialog}
                          disabled={!joData.SwpContNo}>
                          <ArticleRounded color={joData.SwpContNo ? "primary" : "disabled"} />
                        </IconButton>
                      </InputAdornment>
                    }} />
                  <TextField size="small" label="หมายเลขตู้" sx={{ width: 140 }} value={joData.SwpContNo || ""} />
                  <TextField size="small" label="ข้อมูลตู้ตัด" sx={{ flex: 1 }}
                    value={joData.SwpJobOrdIdPrev === null ? ""
                      : `${joData.SwpJobOrdIdPrev}:${joData.SwpContNoPrev}`} />
                </BoxFR>

                : null}
            </BoxFR>
          </BoxFC>
        )

      })}
      {nestedDialogs}
    </BoxFC>
  )
}

export default React.memo(ContStsComponent);